import React, { useRef } from 'react';
import App from './App';
// We're using the ToastContainer from LabLayout.js instead
import 'react-toastify/dist/ReactToastify.css';

/**
 * Wrapper component for IC Creator that provides style isolation
 * when used inside another project that uses Semantic UI React.
 */
const IcCreatorWrapper = ({ user, setTriedToSave, current_locale = 'en' }) => {
  // Check if the locale is RTL (Arabic)
  const isRTL = current_locale === 'ar';
  
  // Create a style isolation container with enhanced styling
  const wrapperStyle = {
    fontFamily: 'Arial, sans-serif',
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    position: 'relative',
    padding: '0',
    margin: '0',
    overflow: 'hidden',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    boxShadow: 'inset 0 0 10px rgba(0,0,0,0.05)',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    direction: isRTL ? 'rtl' : 'ltr'
  };

  // Create a ref to access App component methods
  const appRef = useRef();
  // Create a ref for the wrapper element
  const wrapperRef = useRef(null);

  // Function to create a new IC - will be passed to the App component
  const handleNewIC = () => {
    // This is a reference to the createNewIC function in App.js
    if (appRef.current && appRef.current.createNewIC) {
      appRef.current.createNewIC();
    }
  };
  
  // Set up event listener for the newIC custom event
  React.useEffect(() => {
    const wrapperElement = wrapperRef.current;
    
    if (wrapperElement) {
      const handleNewICEvent = () => handleNewIC();
      wrapperElement.addEventListener('newIC', handleNewICEvent);
      
      return () => {
        wrapperElement.removeEventListener('newIC', handleNewICEvent);
      };
    }
  }, []);

  return (
    <div ref={wrapperRef} className="ic-creator-wrapper" style={wrapperStyle}>
      {/* ToastContainer removed to avoid duplicate notifications */}
      <App ref={appRef} onNew={handleNewIC} user={user} setTriedToSave={setTriedToSave} current_locale={current_locale} isRTL={isRTL}/>
    </div>
  );
};

export default IcCreatorWrapper;
